import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useApp, t } from "@/lib/AppContext";
import { resolveImg } from "@/lib/api";

export default function ThankYou() {
  const { content, settings } = useApp();
  const bg = settings?.bg_image_urls?.thank_you;
  return (
    <section className="relative min-h-[80vh] flex items-center" data-testid="thank-you-page">
      {bg && (
        <div className="absolute inset-0">
          <img src={resolveImg(bg)} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0" style={{ background: "rgba(248,249,250,0.85)" }} />
        </div>
      )}
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-8" style={{ background: "rgba(45,122,58,0.1)" }}>
          <CheckCircle2 size={48} style={{ color: "var(--color-success)" }} />
        </div>
        <h1 className="font-headings font-extrabold text-3xl md:text-5xl text-[var(--color-text-primary)]">{t(content, "thank_you.title", "Спасибо!")}</h1>
        <p className="text-[var(--color-text-secondary)] text-lg mt-5 max-w-xl mx-auto">{t(content, "thank_you.subtitle", "")}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-10">
          <Link to="/" className="btn-primary-cta">{t(content, "thank_you.btn_home", "На главную")}</Link>
          <Link to="/catalog" className="btn-secondary-cta">{t(content, "thank_you.btn_catalog", "В каталог")}</Link>
        </div>
      </div>
    </section>
  );
}
